import React, { useState } from "react";
import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Typography from "@mui/material/Typography";

import SVG from "@/assets/svg";
import CostumeButton from "@/component/button";
import { LIMITS } from "@/utils/constants";
import { DialogueStyled } from "../dialogueStyled";

interface IOverrideIncompatibilityModal {
  onClose: () => void;
  onSubmit: (reason: string) => void;
  message: string;
  serviceUserId?: string;
}

function OverrideIncompatibilityModal({
  onClose,
  onSubmit,
  message,
  serviceUserId,
}: IOverrideIncompatibilityModal) {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!reason.trim()) {
      setError("Override reason is required");
      return;
    }
    onSubmit(reason);
    onClose();
  };

  return (
    <div>
      <DialogueStyled>
        <Box className="behavior">
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h3" sx={{ m: 1 }}>
              Incompatibility Warning
            </Typography>
            <Box onClick={onClose} sx={{ cursor: "pointer" }}>
              <SVG.Cross />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              variant="body1"
              sx={{ color: "rgb(249, 65, 68)", fontWeight: 500 }}
            >
              {message}
            </Typography>
            {serviceUserId && (
              <CostumeButton
                className="export"
                onClick={() =>
                  window.open(
                    `/service/incompatibility/${serviceUserId}`,
                    "_blank"
                  )
                }
                sx={{
                  height: "36px !important",
                  minHeight: "36px !important",
                  fontSize: "12px",
                  fontWeight: 600,
                  lineHeight: "18px",
                  padding: "6px 12px !important",
                  margin: "0 !important",
                  borderRadius: "6px",
                }}
              >
                View All Incompatibilities
              </CostumeButton>
            )}
          </Box>
          <FormGroup>
            <Typography variant="h6" sx={{ color: "#1F4970", mb: 1 }}>
              Provide a reason for overriding this incompatibility:
            </Typography>
            <TextareaAutosize
              minRows={4}
              value={reason}
              placeholder="Enter override reason"
              onChange={(e) => {
                setReason(e.target.value);
                if (e.target.value.trim()) setError("");
              }}
              className="personal"
              style={{
                width: "auto",
                padding: 12,
                borderRadius: 10,
                borderColor: error ? "red" : "#ccc",
              }}
            />
            {error && (
              <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                {error}
              </Typography>
            )}
          </FormGroup>
          <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
            <CostumeButton
              className="invite"
              onClick={handleSave}
              sx={{ width: "120px" }}
            >
              Override
            </CostumeButton>
            <CostumeButton
              className="discard"
              onClick={onClose}
              sx={{ width: "120px" }}
            >
              Cancel
            </CostumeButton>
          </Box>
        </Box>
      </DialogueStyled>
    </div>
  );
}

export default OverrideIncompatibilityModal;
